import config from '@/config'

export default {
  login: "登录到您的帐户",
  relogin: "请重新登录到您的帐户。",
  expired: "会话已过期!",
  denied: "权限被拒绝!",
  success: "您已成功完成!",
  search_by_id: "按ID搜索",
  successful_change_password: "您已成功更改密码。",
  select_option: "选择您的选项",
  no_data_available: "没有可用数据",
  no_rating_available: "没有可用评级",
  successful_update_security: "您已成功更新安全性。",
  successful_disable_security: "您已成功禁用安全性。",
  update_security_confirm: "您确定要更新安全性吗？",
  disable_security_confirm: "您确定要禁用安全性吗？",
  change_operator_status_confirm: "您确定要更改运营商\"\"{name}\"状态吗？",
  change_member_status_confirm: "您确定要更改会员\"\"{name}\"状态吗？",
  change_bank_account_status_confirm: "您确定要更改\"{name}\"帐户状态吗？",
  change_promotion_seq_confirm: "您确定要更改\"{id}\"的顺序吗？",
  change_promo_status_confirm: "您确定要更改\"{name}\"促销状态吗？",
  unlink_promotion_banner_confirm: "您确定要将 {view} 横幅从促销活动\"{id}\"中解除关联吗？",
  change_promo_signup_status_confirm: "您确定要更改\"{name}\"促销注册状态吗？",
  successful_update_account_setup: "您已成功更新帐户设置。",
  unblock_member_confirm: "您确定要解锁会员\"{name}\"吗？",
  unblock_operator_confirm: "您确定要解锁运营商\"{name}\"吗？",
  block_sub_account_confirm: "您确定要封锁子帐户\"{name}\"吗？",
  unblock_sub_account_confirm: "您确定要解锁子帐户\"{name}\"吗？",
  successful_update_account_password: "您已成功更新帐户密码。",
  change_affiliate_status_confirm: "您确定要更改代理\"{name}\"状态吗？",
  unblock_affiliate_confirm: "您确定要解锁代理\"{name}\"吗？",
  change_coupon_status_confirm: "您确定要更改\"{name}\"优惠券状态吗？",
  submit_acknowledgement_confirm: "您确定要提交确认吗？",
  change_bank_group_default_confirm: "您确定要将\"{name}\"设置为默认银行组吗？",
  change_withdrawal_limit_default_confirm: "您确定要将\"{name}\"设置为默认提款限额吗？",
  change_promotion_group_default_confirm: "您确定要将\"{name}\"设置为默认促销组吗？",
  change_withdrawal_limit_confirm: "您确定要更改\"{name}\"提款限额吗？",
  change_promotion_group_confirm: "您确定要更改\"{name}\"促销组吗？",
  change_bank_group_confirm: "您确定要更改\"{name}\"银行组吗？",
  change_member_bet_limit_confirm: "您确定要更改\"{name}\" \"{provider}\"投注限额吗？",
  assign_free_credit_confirm: "您确定要为\"{name}\"分配免费信用吗？",
  update_survey_status_confirm: "您确定要更新调查状态吗？",
  move_banner_up_confirm: "您确定要将横幅\"{name}\"上移吗？",
  move_banner_down_confirm: "您确定要将横幅\"{name}\"下移吗？",
  delete_banner_confirm: "您确定要删除横幅\"{name}\"吗？",
  change_banner_status_confirm: "您确定要更改横幅\"{name}\"状态吗？",
  delete_page_confirm: "您确定要删除页面\"{name}\"吗？",
  change_page_status_confirm: "您确定要更改页面\"{name}\"状态吗？",
  clear_maintenance_time_confirm: "您确定要清除\"{name}\"维护时间吗？",
  successful_clear_outstanding: "您已成功清除{amt}的未结余额。",
  clear_outstanding_confirm: "您确定要清除\"{name}\"未结余额吗？",
  trace_outstanding_confirm: "您确定要跟踪\"{name}\"未结余额吗？",
  delete_ip_address_confirm: "您确定要删除\"{name}\"下的IP地址\"{ip}\"吗？",
  change_payment_mode_status_confirm: "您确定要更改\"{name}\"支付方式状态吗？",
  redeposit_ticket_confirm: "您确定要重新存款工单吗？",
  audit_ticket_confirm: "您确定要审核该工单吗？",
  review_ticket_confirm: "您确定要审查该工单吗？",
  change_promotion_group_seq_confirm: "您确定要更改\"{promotion}\"下的\"{group}\"顺序吗？",
  move_affiliate_confirm: "您确定要将\"{name}\"整个分支代理迁移到\"{operator}\"吗?",
  cancel_unfinish_round_confirm: "您确定要取消未完成的回合 \"{round}\" 吗？",
  change_payment_mode_seq_confirm: "您确定要更改\"{mode}\"的顺序吗？",
  change_label_status_confirm: "您确定要更改\"{name}\"标签状态吗？",
  clear_iframe_url_confirm: "您确定要清除内嵌框架网址吗？",
  delete_turnover_tier_confirm: "您确定要删除 \"{name}\" 流水层级吗？",
  vip_provider_rebate_batch_confirm: "您是否确认继续进行VIP提供商返利批量更新?",
  copy_rebate_rate_all_confirm: "您确定要将 \"{provider}\" 的 \"{name}\" 复制到所有供应商吗？",
  edit_vip_confirm: "您确定要更新 \"{name}\" 的返利率吗？",
  add_promotion_custom_member_confirm: "您确定要添加促销自定义会员列表吗？",
  delete_promotion_custom_member_confirm: "您确定要删除 \"{name}\" 的促销自定义会员列表吗？",
  change_rescue_fund_status_confirm: "您确定要更改 \"{name}\" 的救助基金状态吗？",
  add_rescue_fund_custom_member_confirm: "您确定要添加救助基金自定义会员列表吗？",
  delete_rescue_fund_custom_member_confirm: "您确定要删除 \"{name}\" 的救助基金自定义会员列表吗？",
  change_ads_status_confirm: "您确定要更改 \"{name}\" 广告状态吗？",
  adjust_amount_bank_tooltip: "支持减号 (-) 从银行账户余额中扣除金额",
  adjust_amount_operator_tooltip: "支持减号 (-) 从操作员钱包中扣除金额",
  adjust_amount_member_tooltip: "支持减号 (-) 从会员余额中扣除金额",
  change_provider_game_seq_confirm: "您确定要更改\"{mode}\"的顺序吗？",
  purchase_domain_confirm: "您确定要购买 \"{name}\" 域名吗？",
  search_by_domain_name: "按域名搜索",
  search_by_domain_status: "按域名状态搜索",
  search_by_account_id: "按账户ID搜索",
  search_by_operator_id: "按操作员ID搜索",
  search_by_full_name: "按全名搜索",
  search_by_contact_phone: "按联系电话搜索",
  search_by_signup_ip: "按注册IP搜索",
  search_by_referral_code: "按推荐码搜索",
  search_by_bank_acc_no: "按银行账号搜索",
  search_by_affiliate_code: "按代理代码搜索",
  info1: "1. 不允许使用子域名",
  info2: "2. 不需要输入 'https://' 或 'http://'",
  info3: "3. 示例: abc.com",
  move_announcement_banner: "重新排序横幅",
  atLeastOneChecked: "至少需要勾选一个阈值",
  adjustWalletTooltips: "支持减号 (-) 从代理钱包中扣除余额",
  domain_status_update_confirm: "您想更新 \"{name}\" 的状态吗？",
  move_banner_confirm: "您确定要将 \"{name}\" 更改为位置 \"{position}\" 吗？",
  delete_game_exclude_confirm: "您确定要删除 \"{name}\" 吗？",
  banner_size_tooltips: "请遵循允许的图像尺寸: \"{size}\"。",
  purchase_domain_success: "购买域名成功！",
  apply_domain_success: "应用域名成功！",
  search_by_lang_code: "按语言代码搜索",
  pleaseSelectAnImage: "请选择一张图片",
  pleaseSelectAValidImageType: "请选择有效的图片类型",
  imageTooLargeMaxSizeAllowedIsOneMb: "图片太大,允许的最大尺寸为1MB",
  uploadYourLogoWithPngOrJpegFormat: "请上传您的标志,格式为png或jpeg",
  allowedPngAndJpegOnlyMaxOneMb: "仅允许png和jpeg格式（图片最大尺寸为1MB）",
  delete_theme_content_confirm: "您确定要删除 \"{themecontent}\" 主题内容吗",
  delete_theme_confirm: "您确定要删除 \"{theme}\" 主题吗",
  delete_color_confirm: "您确定要删除 \"{color}\" 颜色吗",
  delete_content_confirm: "您确定要删除 \"{content}\" 内容吗",
  needAiToGenerateLogo: "需要AI来生成标志",
  previewImageForIllustrationOnly: "显示的预览图片仅供说明参考。",
  actualResultMayVary: "实际结果可能会因网站升级而有所不同。",
  delete_theme_content_group_confirm: "您确定要删除 \"{themecontentgroup}\" 主题内容组吗？",
  change_theme_will_replace_menu: "您确定要更新主题吗？(更改主题将导致菜单被替换)",
  change_provider_seq_confirm: "您确定要更改\"{provider}\"的顺序吗？",
  change_provider_status_confirm: "您确定要更改\"{provider}\"提供商状态吗？",
  actionPerformWillReflectProd: "* 在此执行的任何操作将直接影响到生产环境",
  site_sync_confirm: "您确定要同步到生产环境吗",
  clear_profile_setting_maintenance_confirm: "您确定要清除维护吗",
  change_social_platform_status_confirm: "您确定要更改 \"{name}\" 社交平台的状态吗？",
  search_by_site_name: "按网站名称搜索",
  change_social_account_status_confirm: "您确定要更改 \"{name}\" 社交账户状态吗?",
  themeMenuMessage1: "* 通过拖拽菜单项重新排列菜单顺序",
  themeMenuMessage2: "* 如果希望隐藏菜单项,请取消勾选复选框",
  search_by_operator: "按运营商搜索",
  search_by_ticket: "按工单搜索",
  search_member: "搜索会员",
  search_by_game_type: "按游戏类型搜索",
  tooltips_upload_size: "上傳的檔案大小不能超過1mb。",
  tooltips_href: "Href 欄位需要網域的擴充。例如:'yourwebsite.com/promotions',填寫'promotions'即可。",
  d_winlose_chart: "可视化输赢和提款趋势。",
  d_turnover_chart: "分析营业额和存款趋势。",
  d_deposit: "显示存款次数和唯一会员数。",
  d_withdrawal: "显示总提款交易数。",
  d_active_player: "显示玩家的总投注次数和唯一登录数。",
  d_winlose: "显示净输赢总额。",
  d_turnover: "显示总营业额。",
  d_member: "显示所有注册会员的数量。",
  d_referee: "显示用户推荐的总数量。",
  d_verfied_signup: "显示验证用户和新注册用户的数量。",
  d_ftd: "显示首次存款的数量和金额。",
  d_top_winner: "显示玩家ID及总赢额。",
  d_top_loser: "显示玩家ID及总输额。",
  d_top_deposit: "显示玩家ID及从高到低的总存款金额。",
  d_top_withdrawal: "显示玩家ID及从高到低的总提款金额。",
  d_top_promotion: "显示排名、促销ID、名称及玩家领取次数。",
  d_payment_gateway: "显示排名、方法、支付供应商、处理次数、拒绝次数、总次数及成功率。",
  tooltips_promo_member_custom: "請輸入多個會員 ID,並以逗號分隔。例如:member001,member002,member003",
  tooltips_social_facebook: "例如:https://www.facebook.com/",
  tooltips_social_instagram: "例如:https://www.instagram.com/",
  tooltips_social_skype: "例如:skype:<使用者名稱>?chat",
  tooltips_social_telegram: "例如:https://t.me/<ID>",
  tooltips_social_tiktok: "例如: https://www.tiktok.com/<ID>",
  tooltips_social_wechat: "例如:<ID>",
  tooltips_social_whatsapp: "例如:https://wa.me/<ID>",
  tooltips_social_youtube: "例如:https://www.youtube.com/<ID>",
  search_by_business_id: "按商户ID搜索",
  ticket_taken_confirm: "您確定要控制此票證 ID \"{name}\"?",
  tooltips_payment_setting: "仅当“玩家充提规则” - “付款设置”设置为“自定义”时,才会反映以下内容",
  tooltips_cms_announcement_main: "最多5个弹窗广告，以获得最佳用户体验",
  tooltips_cms_announcement_title: "为获得最佳用户体验，最多25个字",
  tooltips_cms_announcement_body: "为获得最佳用户体验，最多200个字,每行40个字",
  delete_livechat_confirm: "您确定要删除在线聊天吗？",
  tooltips_vip_name: "为获得最佳用户体验，最多10个字",
  tooltips_sequence: "序列号越小，游戏优先显示顺序越高",
  tooltips_turnover: "玩家流水",
  tooltips_rebate_rate: "玩家回扣巴仙率",
  tooltips_promo_bonus_rate: "建议保持在100%。超出100%的部分需由商户承担风险。",
  tooltips_promo_signup: "建议保持在AUD1-AUD20。超出AUD1-AUD20的部分需由商户承担风险。",
  tooltips_bonus_issue: "建议保持在AUD1-AUD1000。超出AUD1-AUD1000的部分需由商户承担风险。",
  tooltips_vip_cycle_day: "VIP周期以天为单位。",
  vip_info1: "VIP等级一旦创建后，仅可编辑，不能删除。",
  website_launched: "显示已上线的网站总数、截至所选日期的总网站数、总运营商数和今日活跃网站数。",
  new_player_verified_signup: "显示新增玩家数、活跃玩家总数和截至所选日期的玩家总数。",
  depo_withdrawal_diff: "显示总存款和提款金额的差额以及存款和提款详情。",
  bonus: "显示已领取的奖金总额和成功领取的总次数。",
  ggr: "显示所选日期的总毛博彩收入和会员余额总额。",
  turnover: "显示总营业额和截至所选日期的当前RTP百分比。",
  provider_pt_on_global_confirm: "您确定要更改运营商\"\"{name}\"PT条件吗？",
  approve_affiliate_ticket_confirm: "您确定要批准该代理工单吗？",
  change_payment_option_recommend_confirm: "您确定要更改 \"{mode}\" 下的 \"{group}\" 推荐设置吗？",
  pleaseFillUpSiteDetails: "请填写您的网站详细信息",
  chooseYourPreferedResponsiveLayoutTheme: "请选择您喜好的排版主题",
  chooseYourPreferedColor: "请选择您喜好的色调",
  pleaseSelectTheme: "请选择主题",
  pleaseSelectColor: "请选择色调",
  websiteLayoutAndThemeDesign: "网站布局与设计主题",
  operatorAccCreatedSuccessful: "运营帐户已创建成功",
  search_by_template_code: "按模板代码搜索",
  delete_mini_game_confirm: "您确定要删除 \"{minigame}\" 迷你游戏吗?",
  delete_mini_game_template_confirm: "您确定要删除 \"{minigametemplate}\" 迷你游戏模板吗?",
  search_by_game_name: "按游戏名称搜索",
  tooltips_gamereward: "限制: {max}",
  change_gamify_status_confirm: "你确定要更改 \"{gamify}\" 的奖励状态吗？",
  change_gamify_daily_login_status_confirm: "你确定要更改每日签到（每日登录）奖励状态吗？",
  change_partner_seq_confirm: "您确定要更改\"{id}\"的顺序吗？",
  tooltips_partners_link: "例如:https://www.google.com/",
  delete_partner_confirm: "您确定要删除合作伙伴 \"{name}\" 吗？",
  change_account_chat_status_confirm: "您确定要更改在线客服状态吗？",
  uploadYourManifestWithPngJpegFormat: "请上传 png 或 jpeg 格式的清单",
  whitelist_ip_tooltips: "请通知服务提供商将 IP: \"{ip}\" 地址加入白名单。",
  tooltips_inpay_api_url: "例如: https://www.google.com/",
  delete_android_app_link_confirm: "您确定要删除“{name}”的 Android 应用链接吗？",
  info_app_link: "例如: https://www.google.com/",
  cpi_enrol_confirm: "您确定要报名参加 CPI 吗？",
  change_cpi_member_status_confirm: "您确定要更改 CPI 成员 \"{name}\" 的状态吗？",
  change_leaderboard_status_confirm: "您确定要更改排行榜 \"{name}\" 的状态吗？",
  delete_leaderboard_confirm: "您确定要删除排行榜 \"{name}\" 吗？",
  tooltips_leaderboard_campaign: "最多 5 个活跃的排行榜活动",
  tooltips_cpi_operator_phone: "最多 5 个群组通话",
  delete_phone_confirm: "您确定要删除电话“{name}”吗？",
  excel_format: "用于上传的 Excel 示例格式。",
  choose_an_excel_file: "选择一个 Excel 文件",
  tooltips_cpi_operator_phone_2: "请选择{name}的电话号码",
  will_start_call_now: "将立即开始呼叫",
  withdrawal_confirm: "您确定要从\"{provider}\"提款吗？",
  service_not_available: "服务不可用。",
  change_cpi_custom_assignee_confirm: "您确定要更改自定义 cpi \"{name}\" 的负责人吗？",
  change_cpi_custom_urgency_confirm: "您确定要更改自定义 cpi \"{name}\" 的紧急程度吗？",
  delete_cpi_custom_confirm: "您确定要删除自定义 cpi \"{name}\" 吗？",
  change_ai_assistant_status_confirm: "您确定要更改AI助手的状态吗？",
  please_enter_valid_phone: "请输入有效的电话",
  tooltip_promo_signup: "资金转账提供商不得包含在优惠注册中。",
  tooltips_add_cpi_op_phone: "例如：84123456789",
  tooltips_free_point: "{point} 点数 = {currency} 1",
  search_by_second_id: "按第二ID搜索",
  tooltips_allow_one_active_livechat: "只允许 1 个 LiveChat 同时进行",
  tooltips_add_cpi_op_phone_myr: "60123456789",
  allowedPngOnlyMaxOneMb: "仅允许 PNG（图片大小最大 1MB）",
  uploadYourLogoWithPngFormat: "请上传 PNG 格式的标志",
  add_promotion_voucher_custom_member_confirm: "您确定要添加优惠券自定义会员列表吗？",
  delete_promotion_voucher_custom_member_confirm: "您确定要从优惠券自定义会员列表中删除\"{name}\"吗？",
  redeposit_ticket_voucher_confirm: "您确定要重新充值工单凭证吗？",
  change_mission_status_confirm: "您确定要更改任务 \"{name}\" 的状态吗？",
  mission_reward_at_least_one: "请至少提供一项奖励：积分、额度、收件箱或活动。",
  mission_invalid_reward_numbers: "填写时，积分、额度和收件箱必须为有效数字。",
  mission_campaign_required_when_inbox: "当 Inbox 设置时，请选择 Campaign。",
  mission_rule_target_invalid: "请输入有效的目标值。",
  change_trigger_status_confirm: "您确定要更改触发器\"{name}\"的状态吗？",
  free_credit_withdrawal_amount: "显示截至所选日期的免费额度提款总金额。",
  check_freespin_result_message_0: "0 = 已分配奖励",
  check_freespin_result_message_1: "1 = 免费游戏进行中（玩家已查看 Big Text 且正在旋转）",
  check_freespin_result_message_2: "2 = 免费游戏阶段已完成，正在进行奖励领取流程",
  check_freespin_result_message_3: "3 = 已领取奖励",
  check_freespin_result_message_400: "400 = 奖励已被操作员取消",
  check_freespin_result_message_500: "500 = 奖励已过期",
  cancel_free_round_confirm: "您确定要取消免费回合 \"{round}\" 吗？",
  issue_free_spin_rule: "规则：最高赢额不得大于总线数 × 单线投注 × 投注值 × 5000（MaxWinCapMultiplier）。",
  delete_deposit_tier_confirm: "您确定要删除存款等级 \"存款：{deposit}，奖励：{reward}\" 吗？",
  tooltips_promo_voucher_bonus_rate: "最高奖金比例为2%",
  noExtraSpacingInLogo: "Logo 请勿保留多余留白",
  logoDimensionTips: "尺寸：宽度：最多 250px，高度：50px（例如：250px × 50px）",
  mission_invalid_reward_number_point: "填写时，积分必须为有效数字。",
  mission_reward_enter_point: "请输入积分",
  change_reward_rain_status_confirm: "您确定要更改\"{name}\"的状态吗？",
  cancel_reward_rain_session_confirm: "您确定要取消\"{name}\"吗？",
  change_banner_slide_show_status_confirm: "您确定要更改横幅\"{name}\"的幻灯片播放吗？",
  change_news_status_confirm: "您确定要更改新闻\"{name}\"的状态吗？",
  delete_news_confirm: "您确定要删除新闻\"{name}\"吗？",
  move_news_confirm: "您确定要将\"{name}\"移至\"{position}\"位置吗？",
  info_slug: "每个单词之间请使用一个连字符 (-)。例如：hello-world-test",
};